import React from 'react'
import styled from 'styled-components'
import ChevronLeftFill from '@zendeskgarden/svg-icons/src/12/chevron-left-fill.svg'
import ChevronRightFill from '@zendeskgarden/svg-icons/src/12/chevron-right-fill.svg'
import { Anchor } from '@zendeskgarden/react-buttons'

const RangePagerContainer = styled.div`
  display: flex;
  text-align: center;
  vertical-align: middle;
`

const ChevronContainer = styled.div`
  display: flex;
  width: 75px;
`

const ChevronButton = styled(Anchor)`
  display: inline-block;
  text-align: center;
  vertical-align: middle;
  border: none;
  background: inherit;
  width: 100px;
`

const RangePager = ({ pageNumber, onPageChange, pageTotal }) => {
  const goOlder = () => onPageChange(pageNumber+1)
  const goNewer = () => onPageChange(pageNumber-1)

  const showOlder = pageNumber < pageTotal
  const showNewer = pageNumber > 1

  return (
    <RangePagerContainer>
      <ChevronContainer>
        {showOlder ?
          (
            <ChevronButton onClick={goOlder}>
              <ChevronLeftFill />
              {' '} Previous
            </ChevronButton>
          ) : null}
      </ChevronContainer>
      <ChevronContainer>
        {showNewer ?
          (
            <ChevronButton  onClick={goNewer}>
              Next {' '}
              <ChevronRightFill/>
            </ChevronButton>
          ) : null
        }
      </ChevronContainer>
    </RangePagerContainer>
  )
}

export default RangePager
